const pageIds = {
  InsuredProfilePage: 'insured-profile-page',
  ListInsuredsPage: 'list-insureds-page',
  ListJobsPage: 'list-jobs-page',
  JobProfilePage: 'job-profile-page',
  RequirementTemplatesDropdown: 'requirement-templates-dropdown',
  ReportsPage: 'reports-page',
  AgentPortalPage: 'agent-portal-page',
  CertSubmission: 'cert-submission',
  AdminSettingsPage: 'admin-settings-page',
  EmailAutomationPanel: 'email-automation-panel'
};

export const InsuredProfilePageDuskIds = {
  insuredHeaderName: `${pageIds.InsuredProfilePage}-header-name`,
  insuredRefreshButton: `${pageIds.InsuredProfilePage}-refresh-button`,
  closeInsuredDetailsModal: `${pageIds.InsuredProfilePage}-close-insured-details-modal-button`,
  insuredOverallStatusBadge: `${pageIds.InsuredProfilePage}-overall-status-badge`,
  getRecordStatusBadge: recordId => `${pageIds.InsuredProfilePage}-record-status-badge_record-${recordId}`,
  loadedPolicyGearIconButton: `${pageIds.InsuredProfilePage}-loaded-policy-gear-icon`,
  loadingPolicyGearIconButton: `${pageIds.InsuredProfilePage}-loading-policy-gear-icon`,
  policyRequirementSection: `${pageIds.InsuredProfilePage}-policy-requirement-section`,
  getPolicyRequirementStatusButton: (policyTypeId, policyId) => `${pageIds.InsuredProfilePage}-policy-requirement-button_policy-type-${policyTypeId}_policy-${policyId}`,
  getDocumentRequirementStatusButton: documentTypeId => `${pageIds.InsuredProfilePage}-document-requirement-button_document-type-${documentTypeId}`,
  getArchivedDocumentStatusButton: documentId => `${pageIds.InsuredProfilePage}-archived-document-button_document-id-${documentId}`,
  getArchivedAttachmentStatusButton: attachmentId => `${pageIds.InsuredProfilePage}-archived-attachment-button_attachment-id-${attachmentId}`,
  sendInsuranceRequestButton: 'Send Insurance Request-insured-profile-policies-open-send-email',
  previewInsuranceRequestEmailButton: `${pageIds.InsuredProfilePage}-insurance-request-preview-email-button`,
  sendInsuranceRequestEmailButton: `${pageIds.InsuredProfilePage}-insurance-request-send-email-button`,
  activityLogSection: `${pageIds.InsuredProfilePage}-activity-log-section`,
  refreshActivityLogButton: `${pageIds.InsuredProfilePage}-refresh-activity-log-button`,
  activityLogLoading: `${pageIds.InsuredProfilePage}-activity-log-loading`,
  activityLogLoaded: `${pageIds.InsuredProfilePage}-activity-log-loaded`
};

export const ListInsuredsPageDuskIds = {
  getInsuredRow: insuredId => `${pageIds.ListInsuredsPage}-row_insured-${insuredId}`,
  getInsuredRecordRow: recordId => `${pageIds.ListInsuredsPage}-row_record-${recordId}`
};

export const ListJobsPageDuskIds = {
  getJobDepartmentName: jobId => `${pageIds.ListJobsPage}-department-name_job-${jobId}`,
  getJobActiveRecords: jobId => `${pageIds.ListJobsPage}-active-records_job-${jobId}`,
  getJobApprovalPercentage: jobId => `${pageIds.ListJobsPage}-approval-percentage_job-${jobId}`,
  getJobRowByName: jobName => `${pageIds.ListJobsPage}-job-row_job-name-${jobName}`
};

export const JobProfilePage = {
  jobProfilePageId: pageIds.JobProfilePage,
  activeRecords: `${pageIds.JobProfilePage}-active-records`,
  approvalPercentage: `${pageIds.JobProfilePage}-approval-percentage`,
  getRecordRowById: recordId => `${pageIds.JobProfilePage}-row_record-id-${recordId}`,
  getRecordRowByName: recordName => `${pageIds.JobProfilePage}-row_record-name-${recordName}`,
  getRecordStatusBadge: recordId => `${pageIds.JobProfilePage}-status-badge_record-${recordId}`,
  selectInsuredsOptionButton: `${pageIds.JobProfilePage}-select-insureds-option-button`,
  addInsuredToListOptionButton: `${pageIds.JobProfilePage}-add-insured-to-list-option-button`,
  addInsuredForm: `${pageIds.JobProfilePage}-add-insured-form`,
  insuredCompanyNameInput: `${pageIds.JobProfilePage}-insured-company-name-input`,
  insuredPrimaryEmailInput: `${pageIds.JobProfilePage}-insured-primary-email-input`,
  addInsuredToListButton: `${pageIds.JobProfilePage}-add-insured-to-list-button`,
  addToProjectButton: `${pageIds.JobProfilePage}-add-to-project-button`
};

export const RequirementTemplatesDropdownDuskIds = {
  menuButton: `${pageIds.RequirementTemplatesDropdown}-menu-button`,
  getFolderOptionByName: folderName => `${pageIds.RequirementTemplatesDropdown}-folder-option_folder-name-${folderName}`,
  getTemplateOptionByName: templateName => `${pageIds.RequirementTemplatesDropdown}-template-option_template-name-${templateName}`
};

export const ReportsPageDuskIds = {
  reportsPage: pageIds.ReportsPage,
  getRecordStatusById: recordId => `${pageIds.ReportsPage}-record-status_record-${recordId}`,
  getInsuredStatusById: insuredId => `${pageIds.ReportsPage}-insured-status_insured-${insuredId}`
};

export const AgentPortalDuskIds = {
  agentPortalPage: pageIds.AgentPortalPage,
  verifyEmailInput: `${pageIds.AgentPortalPage}-verify-email-input`,
  verifyFirstInput: `${pageIds.AgentPortalPage}-verify-first-input`,
  verifyLastInput: `${pageIds.AgentPortalPage}-verify-last-input`,
  verifyPhoneInput: `${pageIds.AgentPortalPage}-verify-phone-input`,
  verifyLicenseInput: `${pageIds.AgentPortalPage}-verify-license-input`,
  verifyCompanyInput: `${pageIds.AgentPortalPage}-verify-company-input`,
  verifyAddressInput: `${pageIds.AgentPortalPage}-verify-address-input`,
  editLicenseInput: `${pageIds.AgentPortalPage}-edit-license-input`,
  editCompanyInput: `${pageIds.AgentPortalPage}-edit-company-input`,
  editAddressInput: `${pageIds.AgentPortalPage}-edit-address-input`,
  verifyEmailButton: `${pageIds.AgentPortalPage}-verify-email-button`
};

export const CertSubmissionDuskIds = {
  startSubmissionButton: `${pageIds.CertSubmission}-start-submission-button`,
  uploadDocumentBox: `${pageIds.CertSubmission}-upload-document-box`,
  getDocumentUploadReqDocCheckboxByDocTypeId: docTypeId => `${pageIds.CertSubmission}-req-doc-checkbox_doc-type-${docTypeId}`,
  getDocumentUploadReqPolicyCheckboxByPolicyTypeId: policyTypeId => `${pageIds.CertSubmission}-req-policy-checkbox_policy-type-${policyTypeId}`,
  saveDocumentSelectionButton: `${pageIds.CertSubmission}-save-document-selection-button`,
  continueFromDocumentSelectionBox: `${pageIds.CertSubmission}-continue-from-document-selection-box`,
  skipOcrButton: `${pageIds.CertSubmission}-skip-ocr-button`,
  getPolicyTypePropertyCheckbox: propertyId => `${pageIds.CertSubmission}-policy-type-property-checkbox_property-${propertyId}`,
  getPolicyTypePropertyInput: propertyId => `${pageIds.CertSubmission}-policy-type-property-input_property-${propertyId}`,
  insuranceCompanyDropdownMenu: `${pageIds.CertSubmission}-insurance-company-dropdown-menu`,
  getInsuranceCompanyOption: insuranceCompanyId => `${pageIds.CertSubmission}-insurance-company_id-${insuranceCompanyId}`,
  policyNumberInput: `${pageIds.CertSubmission}-policy-number-input`,
  subrogationWaivedCheckbox: `${pageIds.CertSubmission}-subrogation-waived-checkbox`,
  additionalInsuredCheckbox: `${pageIds.CertSubmission}-additional-insured-checkbox`,
  effectiveOnDateInput: `${pageIds.CertSubmission}-effective-on-date-input`,
  expiresOnDateInput: `${pageIds.CertSubmission}-expires-on-date-input`,
  skipPolicyButton: `${pageIds.CertSubmission}-skip-policy-button`,
  nextPolicyButton: `${pageIds.CertSubmission}-next-policy-button`,
  backPolicyButton: `${pageIds.CertSubmission}-back-policy-button`,
  reviewSubmissionButton: `${pageIds.CertSubmission}-review-submission-button`,
  confirmationLanguageCheckbox: `${pageIds.CertSubmission}-confirmation-language-checkbox`,
  backConfirmationButton: `${pageIds.CertSubmission}-back-confirmation-button`,
  submitCertificateButton: `${pageIds.CertSubmission}-submit-certificate-button`,
  submissionSuccessButton: `${pageIds.CertSubmission}-submission-success-button`
};

export const AdminSettingsPageDuskIds = {
  getUserRowSettingDropdown: userId => `${pageIds.AdminSettingsPage}-user-setting-drop-down-menu_user-id-${userId}`,
  confirmDeleteDepartmentButton: `${pageIds.AdminSettingsPage}-confirm-delete-department-button`
};

export const EmailAutomationPanelDuskIds = {
  emailAutomationSettingsHeader: automationId => `${pageIds.EmailAutomationPanel}-settings-header-${automationId}`,
  emailAutomationSequencesHeader: automationId => `${pageIds.EmailAutomationPanel}-settings-header-${automationId}`
};
